import { render, staticRenderFns } from "./CtrlNensan.vue?vue&type=template&id=1b5e5c72&scoped=true&"
import script from "./CtrlNensan.vue?vue&type=script&lang=ts&"
export * from "./CtrlNensan.vue?vue&type=script&lang=ts&"
import style0 from "./CtrlNensan.vue?vue&type=style&index=0&id=1b5e5c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5e5c72",
  null
  
)

export default component.exports